import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_ACCOUNT_PERMISSIONS,
} from '../../../actions/actionTypes';

const accountPermissions = fetchReducerGenerator(
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_ACCOUNT_PERMISSIONS
);

export default accountPermissions;
